import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments';
import { ApiBaseService } from './api-base.service';
import { PaginationOptions, SearchResult } from '../../common';
import { Hub } from '../abstract/hub.abstract';
import { CpdSurvey } from '../../common/models/cpd/cpd-survey';

@Injectable({
  providedIn: 'root',
})
export class ApiCpdSurveyService extends ApiBaseService {
  protected apiBaseUrl = environment.campusV2;
  protected routePath = `hubs/${this._hubService.hub()}/cpd-survey`; // : string;

  constructor(private _hubService: Hub, private _httpClient: HttpClient) {
    super(_httpClient);

  }

  public getCpdSurveys(
    paginationOptions: PaginationOptions
  ): Promise<SearchResult[]> {
    const path = `?limit=${paginationOptions.limit}&orderby=${paginationOptions.orderBy}&page=${paginationOptions.page}`;

    return super.get<SearchResult[]>(path);
  }

  public async createSurvey(data: CpdSurvey): Promise<void> {
    const path = ``;

    return super.post<void>(path, data);
  }
}
